var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53619 4.30465C4.74447 4.51293 4.74447 4.85061 4.53619 5.05889L2.57664 8.01844L4.53619 10.978C4.74447 11.1863 4.74447 11.5239 4.53619 11.7322C4.32791 11.9405 3.99022 11.9405 3.78194 11.7322L1.44527 8.39556C1.23699 8.18728 1.23699 7.84959 1.44527 7.64131L3.78194 4.30465C3.99022 4.09637 4.32791 4.09637 4.53619 4.30465Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5039 4.30465C11.7121 4.09637 12.0498 4.09637 12.2581 4.30465L14.5948 7.64131C14.8031 7.84959 14.8031 8.18728 14.5948 8.39556L12.2581 11.7322C12.0498 11.9405 11.7121 11.9405 11.5039 11.7322C11.2956 11.5239 11.2956 11.1863 11.5039 10.978L13.4634 8.01844L11.5039 5.05889C11.2956 4.85061 11.2956 4.51293 11.5039 4.30465Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83599 5.49227C9.11548 5.58528 9.26665 5.88724 9.17364 6.16672L7.84031 10.1734C7.7473 10.4529 7.44534 10.604 7.16586 10.511C6.88637 10.418 6.7352 10.1161 6.82821 9.83659L8.16154 5.82992C8.25455 5.55044 8.55651 5.39927 8.83599 5.49227Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.2058c5bb972b7c87fdf668bdc53ffa4f.svg";
export { ForwardRef as ReactComponent };